<template>
    <div class="row">
        <div class="col-md-12">
                <h3 class="text-dark">
                    <i class="el-icon-cpu"></i>
                    <span>Custom Functions</span>
                </h3>
                
                <p>
                    <small>
                        Create and manage custom functions that your agent can use to perform specific tasks or integrations. These functions extend your agent's capabilities beyond standard operations.
                    </small>
                </p>
                
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div></div>
                    <el-button
                        type="primary"
                        plain
                        size="mini"
                        icon="el-icon-plus"
                        data-testid="aloai-add-custom-function-btn"
                        @click="openCustomFunctionModal"
                    >
                        Add function
                    </el-button>
                </div>

                <el-table
                    class="w-full"
                    row-key="uuid"
                    :data="toolsCustomList"
                    stripe
                    data-testid="aloai-custom-functions-table"
                >
                    <el-table-column 
                        label="Name"
                        data-testid="aloai-custom-function-name-column"
                    >
                        <template v-slot="scope">
                            {{ scope.row.name }}
                        </template>
                    </el-table-column>
                    <el-table-column 
                        label="Description"
                        data-testid="aloai-custom-function-description-column"
                    >
                        <template v-slot="scope">
                            {{ scope.row.description }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Actions"
                        align="center"
                        width="100"
                        fixed="right"
                        data-testid="aloai-custom-function-actions-column"
                    >
                        <template v-slot="scope">
                            <button
                                class="btn btn-sm info"
                                @click.prevent="handleCustomFunctionEdit(scope.row)"
                                data-testid="aloai-custom-function-edit-btn"
                            >
                                <i class="fa fa-pencil pull-left"></i>
                            </button>
                            <button
                                class="btn btn-sm danger"
                                @click.prevent="handleCustomFunctionDelete(scope.row.uuid)"
                                data-testid="aloai-custom-function-delete-btn"
                            >
                                <i class="fa fa-trash pull-left"></i>
                            </button>
                        </template>
                    </el-table-column>
                </el-table>
                
                <custom-function
                    v-if="createCustomFunctionDialogVisible"
                    ref="custom_function_dialog"
                    :open="true"
                    :tool="customFunctionData || undefined"
                    @close="onCustomFunctionDialogClose"
                    data-testid="aloai-custom-function-dialog"
                />
        </div>
    </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { mapState } from 'vuex';
import CustomFunction from '../custom-function';

export default {
    name: 'custom-functions-tab',

    components: {
        CustomFunction
    },

    data() {
        return {
            customFunctionData: null,
            createCustomFunctionDialogVisible: false
        }
    },

    computed: {
        ...mapState('aloai', ['tools']),
        
        toolsCustomList() {
            return this.tools.filter(tool => tool.custom_type !== null)
        }
    },

    methods: {
        openCustomFunctionModal() {
            this.customFunctionData = null
            this.createCustomFunctionDialogVisible = true
            
            // Wait for the dialog to be rendered before calling clearForm
            this.$nextTick(() => {
                if (this.$refs.custom_function_dialog && this.$refs.custom_function_dialog.clearForm) {
                    this.$refs.custom_function_dialog.clearForm()
                }
            })
        },

        onCustomFunctionDialogClose() {
            this.customFunctionData = null
            this.createCustomFunctionDialogVisible = false
        },

        handleCustomFunctionEdit(row) {
            this.customFunctionData = row.tool
            this.createCustomFunctionDialogVisible = true
        },

        handleCustomFunctionDelete(uuid) {
            MessageBox.confirm('Are you sure you want to delete this custom function?', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                axios
                    .delete(`/api/v1/aloai/tools/${uuid}`)
                    .then(() => {
                        this.$store.dispatch('aloai/fetchTools', true)
                        
                        this.$notify({
                            offset: 95,
                            title: 'AloAi Custom Functions',
                            dangerouslyUseHTMLString: true,
                            message: 'Custom function deleted successfully.',
                            type: 'success',
                            showClose: true,
                            duration: 5000
                        })
                    })
                    .catch((error) => {
                        this.$notify.error({
                            offset: 95,
                            title: 'AloAi Custom Functions',
                            message: error.response?.data?.message ?? 'There was an error deleting the custom function'
                        })
                    })
            })
        }
    }
}
</script>
